import isPromise from "is-promise";
const promiseMiddleware = () => (next) => (action) => {
  if (isPromise(action)) {
    return action.then((resolvedAction) => {
      if (resolvedAction) {
        return next(resolvedAction);
      }
    });
  }
  return next(action);
};
var promise_middleware_default = promiseMiddleware;
export {
  promise_middleware_default as default
};
//# sourceMappingURL=promise-middleware.js.map
